import React, {useState, useEffect} from "react";
import styled from "styled-components";
import { BACKGROUND_COLOR, BLACK_COLOR, WHITE_COLOR } from "../config/color";
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

const FAQList = [
  {
    asked: '기준가는 무엇인가요?',
    answer: '평균적으로 거래되는 가격을 의미합니다.',
  },
  {
    asked: '최고, 최저 평균 기준가는 무엇인가요?',
    answer: '거래가 되는 가격 중 최고, 최저 가격을 의미합니다.',
  }
]

const FAQWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: ${BACKGROUND_COLOR}; */
  /* border-top: 1px solid white; */
`

const FAQContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 1104px;
  align-items: center;
  padding: 10px 20px;
  @media (max-width: 575px) {
    padding: 0px;
  }
`

const FAQListContainer = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
`

export default () => {
  const classes = useStyles();

  return (
    <FAQWrap>
      <FAQContainer>
      {FAQList.map((o) => {
        return (
            <Accordion style={{width: '100%'}}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>{o.asked}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  {o.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          
        )
      })}
      </FAQContainer>
    </FAQWrap>
  )
}